import { makeRequest } from '../../../lib/api';
import { PricesCalculateStationTireFittingRequest, PricesCalculateStationTireStorageRequest } from '../api/priceCalculateApi';

const PRICE_CALCULATE_PATH = '/v1/prices/calculate'; // расчёт цен

class priceController {
  /* Блок для расчёта цен */
  getPricesCalculateStationTireFitting = (request: PricesCalculateStationTireFittingRequest) => {
    return makeRequest('post', `${ PRICE_CALCULATE_PATH }/station_tire_fitting`, request);
  };

  getPricesCalculateStationStorageFitting = (request: PricesCalculateStationTireStorageRequest) => {
    return makeRequest('post', `${ PRICE_CALCULATE_PATH }/station_tire_storage`, request);
  };
  /* Конец блока для расчёта цен */
}

export default new priceController();
